(function (module) {
    'use strict';
    module.directive('emPremiumStores', function () {
        return {
            scope: {
                stores: '='
            },
            templateUrl: 'directives/premium-stores/premium-stores.tpl.html'
        };
    });
}(angular.module('emarket.commons')));